import { create } from 'zustand'

const handleCheckStylists = (index, set) => {
  set((state) => {
    let newState = [...state.tempActiveStylists.map(stylist => ({ ...stylist }))];
    newState[index].checked = !newState[index].checked;
    return { tempActiveStylists: newState }
  })
}

const handleCheckAll = (bool, set) => {
  set((state) => {
    let newState = [...state.tempActiveStylists.map(stylist => ({ ...stylist }))];
    newState.forEach(stylist => { stylist.checked = bool });
    return { tempActiveStylists: newState }
  })
}

const useStylistsStore = create((set) => ({
  activeStylists: [],
  tempActiveStylists: [],
  setActiveStylists: (as) => set({ activeStylists: as }),
  setTempActiveStylists: (tas) => set({ tempActiveStylists: tas }),
  handleCheckStylists: (index) => handleCheckStylists(index, set),
  handleCheckAll: (bool) => handleCheckAll(bool, set),
}))

export default useStylistsStore;